<template>
  <v-row justify="center">
    <v-dialog
      v-model="show"
      persistent
      width="600">
      <v-card>
        <v-card-text>
          <v-data-table
            :headers="segmentHeaders"
            :items="segmentList"
            :loading="loading"
            :options.sync="options"
            no-data-text="ไม่มีรายการ"
            loading-text="กำลังค้นหาข้อมูล.."
            hide-default-footer
            class="filters-table elevation-1">
            <template v-slot:[`item.createdAt`]="{ item }">
              {{ $dayjs(item.createdAt).tz('Asia/Bangkok').format('DD MMMM YYYY | HH:mm') }}
            </template>
            <template v-slot:[`item.downloadCSV`]="{ item }">
              <v-btn
                v-if="!item.fetching"
                icon
                @click="exportCSV(item)">
                <v-icon>
                  mdi-download
                </v-icon>
              </v-btn>
              <v-progress-circular
                v-else
                title="กำลังดำเนินการ.."
                indeterminate
                width="3"
                size="20"
                color="amber" />
            </template>
            <template v-slot:[`item.deleteSegment`]="{ item }">
              <v-btn
                color="error"
                :disabled="segmentList.length < 2"
                icon
                @click="deleteSegment(item)">
                <v-icon>
                  mdi-delete
                </v-icon>
              </v-btn>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-pagination
            v-model="options.page"
            total-visible="5"
            :length="pageCount" />
          <v-spacer />
          <v-btn
            color="green darken-1"
            text
            @click="closeModal()">
            ปิด
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { mapActions } from 'vuex'
import SegmentProvider from '@/resources/SegmentsProvider'
import SegmentedMembersProvider from '@/resources/SegmentedMembersProvider'
import { ExportToCsv } from 'export-to-csv'

const segmentsService = new SegmentProvider()
const segmentedMembersService = new SegmentedMembersProvider()
export default {
  props: {
    display: {
      type: Boolean,
      default: false
    },
    filterId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      show: false,
      loading: false,
      pageCount: 3,
      totalFilter: 0,
      searching: null,
      CSVFetching: false,
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: ['createdAt'],
        sortDesc: [false]
      },
      segmentList: [],
      segmentHeaders: [
        {
          text: 'วันที่',
          align: 'center',
          sortable: true,
          value: 'createdAt'
        },
        {
          text: 'จำนวน',
          align: 'center',
          sortable: true,
          value: 'amount'
        },
        {
          text: 'ดาวน์โหลดรายชื่อ',
          align: 'center',
          sortable: false,
          value: 'downloadCSV'
        },
        {
          text: 'ลบ',
          align: 'center',
          sortable: false,
          value: 'deleteSegment'
        }
      ]
    }
  },
  watch: {
    display: {
      handler (val) {
        this.show = val
      }
    },
    filterId: {
      handler () {
        this.initSegments()
      }
    },
    options: {
      handler () {
        this.initSegments()
      },
      deep: true
    }
  },
  methods: {
    ...mapActions({
      setSnackBar: 'Style/setSnackbar',
      setModal: 'Style/setModal'
    }),
    closeModal () {
      this.show = false
      this.$emit('close')
    },
    async deleteSegment (segment) {
      try {
        this.loading = true
        await segmentsService.deleteSegmentById(segment.id)
      } catch (e) {
        this.setSnackBar({
          value: true,
          message: `เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง (code ${e.code})`,
          type: 'error'
        })
      } finally {
        this.loading = false
      }
    },
    async initSegments () {
      this.loading = true
      try {
        const { data } = await segmentsService.getSegmentsWithOptions(this.options, this.filterId)
        this.pageCount = data.pages
        this.totalFilter = data.total
        this.segmentList = data.results.map((segment) => ({
          name: segment.filter.name,
          id: segment.id,
          createdAt: segment.createdAt,
          amount: segment.totalUser,
          fetching: false
        }))
      } catch (e) {
        this.setSnackBar({
          value: true,
          message: `เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง (code ${e.code})`,
          type: 'error'
        })
      } finally {
        this.loading = false
      }
    },
    async exportCSV (segment) {
      const segmentID = segment.id
      const segmentPointer = this.segmentList.findIndex((each) => each.id === segmentID)
      this.segmentList[segmentPointer].fetching = true
      try {
        const { data } = await segmentedMembersService.getMembersBySegmentID(segmentID)
        const preExport = data.map((item) => {
          let moreString = ''
          item.more.forEach((element, index) => {
            const field = Object.keys(element)
            if (typeof element[field] !== 'object') {
              if (Array.isArray(field)) {
                field.forEach((key) => {
                  moreString += `${key} -> ${element[key].toString()} | `
                })
                moreString += ']'
              } else {
                moreString += `[${index + 1} (${field}): ${element[field].toString()}] `
              }
            } else {
              moreString += `[${index + 1} (${field}): `
              Object.keys(element[field]).forEach((key) => {
                moreString += `${key} -> ${element[field][key]} | `
              })
              moreString += ']'
            }
          })
          const memberDate = item.memberDate ? this.$dayjs(item.memberDate).tz('Asia/Bangkok').format('YYYY-MM-DD | HH:mm') : ''
          const vipDate = item.vipDate ? this.$dayjs(item.vipDate).tz('Asia/Bangkok').format('YYYY-MM-DD | HH:mm') : ''
          const vvipDate = item.vvipDate ? this.$dayjs(item.vvipDate).tz('Asia/Bangkok').format('YYYY-MM-DD | HH:mm') : ''
          return {
            'Tel no.': item.tel,
            'ID': item.memberId,
            'Type of member': item.type,
            'Fullname': `${item.firstName} ${item.lastName}`,
            'Birthdate': this.$dayjs(item.birthDate).tz('Asia/Bangkok').format('YYYY-MM-DD'),
            'Gender': item.gender,
            'Email': item.email,
            'From': item.createdIn,
            'Point': item.point,
            'Member Date': memberDate,
            'VIP Date': vipDate,
            'VIP Spent': item.spending.vip || '',
            'VVIP Date': vvipDate,
            'VVIP Spent': item.spending.vvip || '',
            'Total Spent': item.spending.total || 0,
            'Card Id': item.cardId || '',
            'Note': item.note || '',
            'More': moreString || ''
          }
        })

        const options = {
          filename: `${segment.name}(${this.$dayjs().format('YYYY-MM-DDTHH-mm')})`,
          showLabels: true,
          useKeysAsHeaders: true
        }
        const csvExporter = new ExportToCsv(options)
        csvExporter.generateCsv(preExport)
        this.closeModal()
      } catch (e) {
        console.error(e)
        this.setSnackBar({
          value: true,
          message: `เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง (code ${e.code})`,
          type: 'error'
        })
      } finally {
        this.segmentList[segmentPointer].fetching = false
      }
    }
  }
}
</script>
